import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, variant, children, onClick }: ButtonProps) => (
  <StyledButton color={color} variant={variant} onClick={onClick}>
    {children}
  </StyledButton>
);
